import "./card.css";

interface Props {
  title: string;
  icon: string;
  number: string | number;
  onClick: any;
  btnText: string;
}

const CommonCard = ({ title, icon, number, onClick, btnText }: Props) => {
  return (
    <div className="dashboardCardWrapper">
      <div className="card_holder">
        <img src={icon} className="card_icon" />
        <div className="card_details">
          <span className="card_title">{title}</span>
          <span className="card_number">{number}</span>
        </div>
      </div>
      <div onClick={onClick} className="card_holder_btn">
        {btnText}
      </div>
    </div>
  );
};

export default CommonCard;
